(function (window, document) {
  'use strict';

  if (window.__TBA_FULL_FUNNEL_TRACKING_V1__) return;
  window.__TBA_FULL_FUNNEL_TRACKING_V1__ = true;

  window.dataLayer = window.dataLayer || [];

  var STORAGE_PREFIX = 'tba_tracking_v1_';
  var PAGE_SEEN = Object.create(null);
  var formStarted = false;
  var lastFormStep = null;
  var touchState = null;

  function uuid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (error) {}

    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }

  function safeGet(storage, key) {
    try {
      return storage.getItem(STORAGE_PREFIX + key);
    } catch (error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(STORAGE_PREFIX + key, value);
    } catch (error) {}
  }

  function readJson(storage, key) {
    var raw = safeGet(storage, key);
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function writeJson(storage, key, value) {
    safeSet(storage, key, JSON.stringify(value));
  }

  function cleanText(value, maxLength) {
    var output = String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();

    if (maxLength && output.length > maxLength) {
      output = output.slice(0, maxLength);
    }

    return output;
  }

  function getCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];

    for (var index = 0; index < parts.length; index += 1) {
      var item = parts[index].trim();
      if (item.indexOf(prefix) === 0) {
        return decodeURIComponent(item.slice(prefix.length));
      }
    }

    return '';
  }

  function externalReferrer() {
    if (!document.referrer) return '';

    try {
      var referrerUrl = new URL(document.referrer);
      if (referrerUrl.hostname === window.location.hostname) return '';
      return referrerUrl.href;
    } catch (error) {
      return '';
    }
  }

  function inferPageType() {
    var path = window.location.pathname || '/';

    if (path === '/' || path === '') return 'home';
    if (/^\/blogs\/[^/]+\/[^/]+/.test(path)) return 'article';
    if (/^\/blogs\//.test(path)) return 'blog';
    if (/^\/pages\//.test(path)) return 'page';
    return 'other';
  }

  function getCampaignContext() {
    var params = new URLSearchParams(window.location.search || '');
    var referrer = externalReferrer();
    var source = cleanText(params.get('utm_source'));
    var medium = cleanText(params.get('utm_medium'));
    var campaign = cleanText(params.get('utm_campaign'));
    var content = cleanText(params.get('utm_content'));
    var term = cleanText(params.get('utm_term'));

    var gclid = cleanText(params.get('gclid'));
    var gbraid = cleanText(params.get('gbraid'));
    var wbraid = cleanText(params.get('wbraid'));
    var fbclid = cleanText(params.get('fbclid'));
    var liFatId = cleanText(params.get('li_fat_id'));

    if (!source && (gclid || gbraid || wbraid)) {
      source = 'google';
      medium = medium || 'cpc';
    } else if (!source && fbclid) {
      source = 'facebook';
      medium = medium || 'paid_social';
    } else if (!source && liFatId) {
      source = 'linkedin';
      medium = medium || 'paid_social';
    } else if (!source && referrer) {
      try {
        source = new URL(referrer).hostname.replace(/^www\./, '');
      } catch (error) {
        source = 'referral';
      }
      medium = medium || 'referral';
    }

    if (!source) source = '(direct)';
    if (!medium) medium = '(none)';
    if (!campaign) campaign = '(not set)';

    return {
      source: source,
      medium: medium,
      campaign: campaign,
      content: content,
      term: term,
      landing_page: window.location.href,
      external_referrer: referrer,
      gclid: gclid,
      gbraid: gbraid,
      wbraid: wbraid,
      fbclid: fbclid,
      li_fat_id: liFatId
    };
  }

  function isDirect(context) {
    return (
      context.source === '(direct)' &&
      context.medium === '(none)' &&
      !context.gclid &&
      !context.gbraid &&
      !context.wbraid &&
      !context.fbclid &&
      !context.li_fat_id
    );
  }

  var currentCampaign = getCampaignContext();
  var firstTouch = readJson(window.localStorage, 'first_touch');
  var lastTouch = readJson(window.localStorage, 'last_touch');

  if (!firstTouch) {
    firstTouch = currentCampaign;
    writeJson(window.localStorage, 'first_touch', firstTouch);
  }

  if (!lastTouch || !isDirect(currentCampaign)) {
    lastTouch = currentCampaign;
    writeJson(window.localStorage, 'last_touch', lastTouch);
  }

  var sessionId = safeGet(window.sessionStorage, 'session_id');
  if (!sessionId) {
    sessionId = 'tba-session-' + uuid();
    safeSet(window.sessionStorage, 'session_id', sessionId);
  }

  function analyticsAllowed() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      ) {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (error) {}

    return true;
  }

  function marketingAllowed() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'
      ) {
        return window.Shopify.customerPrivacy.marketingAllowed();
      }
    } catch (error) {}

    return true;
  }

  function commonContext() {
    return {
      event_id: uuid(),
      tba_session_id: sessionId,
      page_type: inferPageType(),
      page_path: window.location.pathname || '/',
      page_title: cleanText(document.title, 150),

      first_touch_source: firstTouch ? firstTouch.source : '',
      first_touch_medium: firstTouch ? firstTouch.medium : '',
      first_touch_campaign: firstTouch ? firstTouch.campaign : '',
      first_touch_content: firstTouch ? firstTouch.content : '',
      first_touch_term: firstTouch ? firstTouch.term : '',

      last_touch_source: lastTouch ? lastTouch.source : '',
      last_touch_medium: lastTouch ? lastTouch.medium : '',
      last_touch_campaign: lastTouch ? lastTouch.campaign : '',
      last_touch_content: lastTouch ? lastTouch.content : '',
      last_touch_term: lastTouch ? lastTouch.term : '',

      landing_page: firstTouch ? firstTouch.landing_page : window.location.href,
      external_referrer: firstTouch ? firstTouch.external_referrer : externalReferrer(),

      gclid: currentCampaign.gclid || (lastTouch && lastTouch.gclid) || '',
      gbraid: currentCampaign.gbraid || (lastTouch && lastTouch.gbraid) || '',
      wbraid: currentCampaign.wbraid || (lastTouch && lastTouch.wbraid) || '',
      fbclid: currentCampaign.fbclid || (lastTouch && lastTouch.fbclid) || '',
      li_fat_id: currentCampaign.li_fat_id || (lastTouch && lastTouch.li_fat_id) || '',
      _fbp: getCookie('_fbp'),
      _fbc: getCookie('_fbc')
    };
  }

  function normaliseParameters(parameters) {
    var output = {};
    var input = parameters || {};

    Object.keys(input).forEach(function (key) {
      var value = input[key];

      if (value == null) return;

      if (Array.isArray(value)) {
        output[key] = value.map(function (item) {
          return cleanText(item, 100);
        }).join('|');
        return;
      }

      if (typeof value === 'boolean' || typeof value === 'number') {
        output[key] = value;
        return;
      }

      if (typeof value === 'string') {
        output[key] = cleanText(value, 250);
      }
    });

    return output;
  }

  function push(eventName, parameters, options) {
    if (!eventName || eventName.indexOf('tba_') !== 0) return null;

    var settings = options || {};
    var onceKey = settings.onceKey || '';

    if (onceKey && PAGE_SEEN[onceKey]) return null;
    if (onceKey) PAGE_SEEN[onceKey] = true;

    if (settings.requireAnalytics !== false && !analyticsAllowed()) {
      return null;
    }

    var payload = Object.assign(
      { event: eventName },
      commonContext(),
      normaliseParameters(parameters)
    );

    window.dataLayer.push(payload);
    return payload;
  }

  window.TBATracking = {
    push: push,
    sessionId: sessionId,
    analyticsAllowed: analyticsAllowed,
    marketingAllowed: marketingAllowed,
    attribution: {
      firstTouch: firstTouch,
      lastTouch: lastTouch
    }
  };

  function closestSectionName(element) {
    if (!element || !element.closest) return '';

    var section = element.closest(
      '#top, #about, #services, #materials, #industries, #process, #portfolio, #contact, #faq, #insights, .final-cta'
    );

    if (!section) return '';
    if (section.classList.contains('final-cta')) return 'final_cta';
    if (section.id === 'top') return 'hero';
    return section.id || '';
  }

  function navigationLocation(element) {
    if (!element || !element.closest) return '';

    if (element.closest('#tba-header .tba-mobile-panel')) return 'header_mobile';
    if (element.closest('#tba-header')) return 'header_desktop';
    if (element.closest('#tba-footer')) return 'footer';
    if (element.closest('.tba-mobile-sticky')) return 'mobile_sticky';
    return closestSectionName(element) || 'page';
  }

  function portfolioContext(element) {
    var card = element && element.closest ? element.closest('.work-card') : null;
    var category = card ? cleanText(card.getAttribute('data-cats'), 80) : '';
    var titleElement = card ? card.querySelector('.work-title') : null;

    return {
      portfolio_category: category,
      portfolio_title: titleElement ? cleanText(titleElement.textContent, 100) : ''
    };
  }

  function serviceContext(element) {
    var card = element && element.closest ? element.closest('.service-card') : null;
    var heading = card ? card.querySelector('h3') : null;
    return heading ? cleanText(heading.textContent, 100) : '';
  }

  function articleTitle(element) {
    if (!element || !element.closest) return '';

    var card = element.closest('.insight-card');
    var heading = card ? card.querySelector('h3') : null;

    return heading
      ? cleanText(heading.textContent, 150)
      : cleanText(element.textContent, 150);
  }

  function registerSectionViews() {
    if (!('IntersectionObserver' in window)) return;

    var sectionMap = [
      ['#top', 'hero'],
      ['#about', 'about'],
      ['#services', 'services'],
      ['#materials', 'materials'],
      ['#industries', 'industries'],
      ['#process', 'process'],
      ['#portfolio', 'portfolio'],
      ['#contact', 'contact'],
      ['#faq', 'faq'],
      ['#insights', 'articles'],
      ['.final-cta', 'final_cta']
    ];

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.30) return;

        var sectionName = entry.target.getAttribute('data-tba-section-name');
        if (!sectionName) return;

        push(
          'tba_section_view',
          { section_name: sectionName },
          { onceKey: 'section:' + sectionName }
        );

        observer.unobserve(entry.target);
      });
    }, { threshold: [0.30] });

    sectionMap.forEach(function (item) {
      var element = document.querySelector(item[0]);
      if (!element || element.getAttribute('data-tba-section-observed') === 'true') {
        return;
      }

      element.setAttribute('data-tba-section-observed', 'true');
      element.setAttribute('data-tba-section-name', item[1]);
      observer.observe(element);
    });
  }

  function registerFormTracking() {
    var form = document.querySelector('[data-brief-form]');
    if (!form || form.getAttribute('data-tba-tracking-bound') === 'true') return;

    form.setAttribute('data-tba-tracking-bound', 'true');

    if ('IntersectionObserver' in window) {
      var formObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.25) return;

          push(
            'tba_form_view',
            { form_name: 'project_enquiry' },
            { onceKey: 'form_view:project_enquiry' }
          );

          formObserver.disconnect();
        });
      }, { threshold: [0.25] });

      formObserver.observe(form);
    }

    function startForm(event) {
      if (formStarted) return;

      var target = event && event.target;
      if (
        target &&
        target.matches &&
        target.matches('[data-brief-back], [data-brief-next], [data-brief-submit]')
      ) {
        return;
      }

      formStarted = true;
      push('tba_form_start', {
        form_name: 'project_enquiry',
        form_step_name: currentFormStep().name,
        form_step_number: currentFormStep().number
      });
    }

    form.addEventListener('input', startForm, true);
    form.addEventListener('change', startForm, true);
    form.addEventListener('click', startForm, true);

    form.addEventListener('invalid', function (event) {
      var field = event.target;
      var active = currentFormStep();

      push('tba_form_validation_error', {
        form_name: 'project_enquiry',
        form_step_name: active.name,
        form_step_number: active.number,
        error_type: 'invalid_field',
        error_field: cleanText(
          field.getAttribute('data-summary-label') ||
          field.getAttribute('name') ||
          field.id ||
          field.type,
          100
        )
      });
    }, true);

    var submitButton = form.querySelector('[data-brief-submit]');
    if (submitButton) {
      submitButton.addEventListener('click', function () {
        var step = currentFormStep();

        push('tba_lead_submit_attempt', {
          form_name: 'project_enquiry',
          form_step_name: step.name,
          form_step_number: step.number,
          completion_percentage: step.percentage
        });
      });
    }

    observeFormSteps(form);
  }

  function currentFormStep() {
    var form = document.querySelector('[data-brief-form]');
    if (!form) return { name: '', number: 0, percentage: 0 };

    var allSteps = Array.prototype.slice.call(form.querySelectorAll('.brief-step'));
    var visibleSteps = allSteps.filter(function (step) {
      return !step.hidden;
    });

    var active = visibleSteps.find(function (step) {
      return step.classList.contains('is-active');
    }) || visibleSteps[0] || null;

    var number = active ? visibleSteps.indexOf(active) + 1 : 0;
    var percentage = visibleSteps.length
      ? Math.round((number / visibleSteps.length) * 100)
      : 0;

    return {
      element: active,
      name: active ? cleanText(active.getAttribute('data-step-title'), 100) : '',
      number: number,
      percentage: percentage
    };
  }

  function observeFormSteps(form) {
    function recordStep() {
      var step = currentFormStep();
      if (!step.element || !step.name) return;

      var key = step.number + ':' + step.name;
      if (lastFormStep === key) return;
      lastFormStep = key;

      push('tba_form_step_view', {
        form_name: 'project_enquiry',
        form_step_name: step.name,
        form_step_number: step.number,
        completion_percentage: step.percentage
      });
    }

    recordStep();

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return (
          mutation.type === 'attributes' &&
          (mutation.attributeName === 'hidden' ||
           mutation.attributeName === 'class')
        );
      });

      if (relevant) {
        window.requestAnimationFrame(recordStep);
      }
    });

    form.querySelectorAll('.brief-step').forEach(function (step) {
      observer.observe(step, {
        attributes: true,
        attributeFilter: ['hidden', 'class']
      });
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a, button, summary');
    if (!target) return;

    if (target.closest('[data-brief-form]')) return;

    var href = cleanText(target.getAttribute('href'), 250);
    var text = cleanText(
      target.getAttribute('aria-label') ||
      target.textContent ||
      target.getAttribute('title'),
      150
    );
    var location = navigationLocation(target);
    var sectionName = closestSectionName(target);

    if (target.matches('[data-material-tab]')) {
      push('tba_material_select', {
        material_name: target.getAttribute('data-material-tab'),
        selection_location: 'materials'
      });
      return;
    }

    if (target.matches('[data-filter]')) {
      push('tba_portfolio_filter', {
        portfolio_category: target.getAttribute('data-filter'),
        selection_location: 'portfolio'
      });
      return;
    }

    if (target.matches('[data-carousel-prev], [data-carousel-next], [data-carousel-dot]')) {
      var portfolio = portfolioContext(target);
      var carousel = target.closest('[data-work-carousel]');
      var dots = carousel
        ? Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'))
        : [];
      var activeIndex = dots.findIndex(function (dot) {
        return dot.classList.contains('is-active');
      });
      var intendedIndex = activeIndex;

      if (target.matches('[data-carousel-dot]')) {
        intendedIndex = parseInt(target.getAttribute('data-carousel-dot'), 10) || 0;
      } else if (target.matches('[data-carousel-prev]')) {
        intendedIndex = dots.length
          ? (activeIndex - 1 + dots.length) % dots.length
          : 0;
      } else if (target.matches('[data-carousel-next]')) {
        intendedIndex = dots.length
          ? (activeIndex + 1) % dots.length
          : 0;
      }

      push('tba_portfolio_slide', Object.assign({}, portfolio, {
        slide_index: intendedIndex + 1,
        slide_count: dots.length || 1,
        interaction_method: target.matches('[data-carousel-dot]')
          ? 'dot'
          : target.matches('[data-carousel-prev]')
            ? 'previous'
            : 'next'
      }));
      return;
    }

    if (target.classList.contains('work-link')) {
      push(
        'tba_portfolio_enquiry_click',
        Object.assign({}, portfolioContext(target), {
          cta_name: text,
          cta_location: 'portfolio'
        })
      );
      return;
    }

    if (target.classList.contains('text-cta')) {
      push('tba_service_select', {
        service_name: serviceContext(target),
        cta_name: text,
        cta_location: 'services'
      });
      return;
    }

    if (href.indexOf('tel:') === 0 || href.indexOf('mailto:') === 0) {
      push('tba_contact_click', {
        contact_method: href.indexOf('tel:') === 0 ? 'phone' : 'email',
        link_text: text,
        link_url: href,
        navigation_location: location
      });
      return;
    }

    if (
      target.classList.contains('insight-card') ||
      href.indexOf('/blogs/') === 0
    ) {
      push('tba_article_click', {
        article_title: articleTitle(target),
        link_text: text,
        link_url: href,
        navigation_location: location
      });
      return;
    }

    if (
      text.toLowerCase().indexOf('brochure') !== -1 ||
      target.getAttribute('title') === 'View The Box Artisans company brochure'
    ) {
      push('tba_brochure_click', {
        link_text: text,
        link_url: href,
        cta_location: sectionName || location
      });
      return;
    }

    if (
      href === '#contact' ||
      href === '/#contact' ||
      target.classList.contains('tba-quote-btn') ||
      target.classList.contains('btn')
    ) {
      push('tba_cta_click', {
        cta_name: text,
        cta_location: sectionName || location,
        link_url: href
      });
      return;
    }

    if (
      target.closest('#tba-header') ||
      target.closest('#tba-footer') ||
      target.closest('.tba-mobile-sticky')
    ) {
      push('tba_navigation_click', {
        navigation_location: location,
        link_text: text,
        link_url: href
      });
    }
  }, true);

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (
      !details ||
      details.tagName !== 'DETAILS' ||
      !details.open ||
      !details.closest('#faq')
    ) {
      return;
    }

    var questions = Array.prototype.slice.call(
      details.closest('.accordion').querySelectorAll('details')
    );
    var summary = details.querySelector('summary');

    push('tba_faq_open', {
      faq_question: summary ? cleanText(summary.textContent, 200) : '',
      faq_position: questions.indexOf(details) + 1
    });
  }, true);

  document.addEventListener('touchstart', function (event) {
    var carousel = event.target.closest('[data-work-carousel]');
    if (!carousel || !event.changedTouches || !event.changedTouches.length) return;

    touchState = {
      carousel: carousel,
      x: event.changedTouches[0].clientX
    };
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (event) {
    if (!touchState || !event.changedTouches || !event.changedTouches.length) {
      touchState = null;
      return;
    }

    var distance = event.changedTouches[0].clientX - touchState.x;
    var carousel = touchState.carousel;
    touchState = null;

    if (Math.abs(distance) <= 45 || !carousel) return;

    var card = carousel.closest('.work-card');
    var dots = Array.prototype.slice.call(
      carousel.querySelectorAll('[data-carousel-dot]')
    );
    var activeIndex = dots.findIndex(function (dot) {
      return dot.classList.contains('is-active');
    });
    var direction = distance < 0 ? 1 : -1;
    var nextIndex = dots.length
      ? (activeIndex + direction + dots.length) % dots.length
      : 0;

    push('tba_portfolio_slide', Object.assign(
      {},
      portfolioContext(card || carousel),
      {
        slide_index: nextIndex + 1,
        slide_count: dots.length || 1,
        interaction_method: 'swipe'
      }
    ));
  }, { passive: true, capture: true });

  function initialise() {
    registerSectionViews();
    registerFormTracking();

    push(
      'tba_tracking_ready',
      {
        section_name: 'tracking',
        analytics_consent: analyticsAllowed(),
        marketing_consent: marketingAllowed()
      },
      {
        onceKey: 'tracking_ready',
        requireAnalytics: false
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', function () {
    registerSectionViews();
    registerFormTracking();
  });

  document.addEventListener('visitorConsentCollected', function () {
    push(
      'tba_consent_update',
      {
        analytics_consent: analyticsAllowed(),
        marketing_consent: marketingAllowed()
      },
      { requireAnalytics: false }
    );
  });
})(window, document);
